import { render } from "./CampoData.vue?vue&type=template&id=a12fd992&scoped=true"
import script from "./CampoData.vue?vue&type=script&lang=js"
export * from "./CampoData.vue?vue&type=script&lang=js"

import "./CampoData.vue?vue&type=style&index=0&id=a12fd992&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a12fd992"]])

export default __exports__